import React from 'react';
import { BooleanField, Datagrid, List, TextField } from 'react-admin';
import { CustomDateField } from '../../../../commonComponents/DateField';
import CustomReportListActions from '../../../../commonComponents/ListActions/CustomReportListActions';
import WordleGameFilter from './WordleGameFilter';

const WordleGameList = (props) => (
  <List
    title="Wordle Game reports"
    actions={<CustomReportListActions />}
    filters={<WordleGameFilter />}
    bulkActionButtons={false}
    sort={{ field: 'user_id', order: 'DESC' }}
    {...props}
  >
    <Datagrid>
      <TextField label="ID" source="id" sortable={false} />
      <TextField label="User ID" source="user_id" sortBy="user_id" sortable={true} />
      <TextField label="Wordle game ID" source="wordle_event_id" sortable={true} />
      <CustomDateField label="Date created" source="game_date" sortable={true} showTime={false} locales={'hu'} />
      <TextField label="Number of words entered" source="number_of_words_entered" />
      <TextField label="Total hints earned" source="total_hints_earned" />
      <TextField label="Won game" source="won_game" />
      <TextField label="Total coins earned" source="total_coins_earned" />
      <TextField label="Total extra help used" source="total_extra_help_used" />
      <BooleanField label="Earned 2000 credits" source="earned_2000_credits" />
      <BooleanField label="Has completed quests" source="has_completed_quests" />
    </Datagrid>
  </List>
);

export default WordleGameList;
